import configuracion from '@/config';
import Vue from 'vue'

const state = {
  configuracionCargada: false,
  estados: {
    polizaSolicitud: 1,
    polizaVigor: 2,
    polizaAnulada: 3,
    siniestroAbierto: 1,
    siniestroCerrado: 2,
    proyectoAbierto: 1,
    proyectoPerdido: 2,
    proyectoGanado: 3,
    avisoNoLeido: 1,
    avisoLeido: 2
  },
  parametros: [],
  urlBase: configuracion.urlBase,
  logoClaro: configuracion.logoClaro,
  logoOscuro: configuracion.logoOscuro,
  perfilUsuario: configuracion.perfilUsuario,
  tiempoRecargaAvisos: configuracion.tiempoRecargaAvisos * 1000,
  nombreCorreduria: configuracion.nombreCorreduria,
  nombreCortoCorreduria: configuracion.nombreCorto,
  direccionCorreduria: configuracion.direccionCorreduria,
  telefonoCorreduria: configuracion.telefonoCorreduria
}

const getters = {
  estados(state) {
    return state.estados
  },
  urlBase(state) {
    return state.urlBase
  },
  perfilUsuario(state) {
    return state.perfilUsuario
  },
  logoClaro(state) {
    return state.logoClaro
  },
  logoOscuro(state) {
    return state.logoOscuro
  },
  parametros(state) {
    return state.parametros
  },
  configuracionCargada(state) {
    return state.configuracionCargada
  },
  tiempoRecargaAvisos(state) {
    return state.tiempoRecargaAvisos
  },
  nombreCorreduria(state) {
    return state.nombreCorreduria
  },
  nombreCortoCorreduria(state) {
    return state.nombreCortoCorreduria
  },
  direccionCorreduria(state) {
    return state.direccionCorreduria
  },
  telefonoCorreduria(state) {
    return state.telefonoCorreduria
  }
}

const actions = {
  loadParametros(context) {
    let url = context.getters.urlBase + 'parametros'
    Vue.http.get(url).then(
      (response) => {
        context.commit("setParametros", response.body.items)
        context.commit("setConfiguracionCargada", true)
      },
      (error) => {
      }
    );
  },
  setConfiguracionCargada(context, payload) {
    context.commit('setConfiguacionCargada', payload.estado)
  },
  setParametros(context, payload) {
    context.commit("setParametros", payload.parametros)
  }
}

const mutations = {
  setParametros(state, parametros) {
    let params = {}
    for (let i = 0; i < parametros.length; i++) {
      switch(parametros[i].tipo) {
        case 'int':
          if (parametros[i].valor) {
            params[parametros[i].parametro.toLowerCase()] = parseInt(parametros[i].valor)
          } else {
            params[parametros[i].parametro.toLowerCase()] = null
          }
          break;
        case 'array':
          if (parametros[i].valor) {
            params[parametros[i].parametro.toLowerCase()] = parametros[i].valor.split(",")
          } else {
            params[parametros[i].parametro.toLowerCase()] = null
          }
          break;
        case 'boolean':
          if (parametros[i].valor == 'true') {
            params[parametros[i].parametro.toLowerCase()] = true
          } else {
            params[parametros[i].parametro.toLowerCase()] = false
          }
          break;
        default:
          params[parametros[i].parametro.toLowerCase()] = parametros[i].valor
      }
    }
    state.parametros = params
  },
  setConfiguracionCargada(state, estado) {
    state.configuracionCargada = estado
  }
}

export default {
    state,
    getters,
    actions,
    mutations
}
